import React, { memo } from 'react';
import PropTypes from 'prop-types';
import dynamic from 'next/dynamic';
import { COMPLETED_PROFILE_SECTIONS_NAMES, TP } from '../../../../constants/consts';
import { EditLayout } from '../../../../components/EditComponents/EditLayout';
import { checkCompletion } from '../../../../utils/editCommon';
import FestivalBasicInfo from './components/FestivalBasicInfo';

const FestivalContacts = dynamic(import('./components/FestivalContacts'));
const FestivalDigitalPresence = dynamic(import('./components/FestivalDigitalPresence'));
const FestivalStaff = dynamic(import('./components/FestivalStaff'));
const FestivalVenues = dynamic(import('./components/FestivalVenues'));
// const FestivalVideo = dynamic(import('./components/FestivalVideo'));
const FestivalImages = dynamic(import('./components/FestivalImages'));
// const FestivalPress = dynamic(import('./components/FestivalPress'));

const tabValues = {
  basic: 'basic',
  contacts: 'contacts',
  digital: 'digital',
  staff: 'staff',
  venues: 'venues',
  video: 'video',
  images: 'images',
  press: 'press',
};

export function EditFestival({ festival }) {
  const completedSections = festival?.completedSections || [];

  const tabs = {
    [tabValues.basic]: {
      value: tabValues.basic,
      name: `${TP}.FN_BASIC_INFO_TITLE`,
      title: `${TP}.FN_BASIC_INFO_TITLE`,
      subtitle: `${TP}.FN_FESTIVAL_BASIC_INFO_SUBTITLE`,
      form: <FestivalBasicInfo goToNextTab={() => goToTab(tabValues.contacts)} />,
      isFilled: checkCompletion(completedSections, COMPLETED_PROFILE_SECTIONS_NAMES.BASIC_INFORMATION),
    },
    [tabValues.contacts]: {
      value: tabValues.contacts,
      name: `${TP}.FN_CONTACT_INFO_TITLE`,
      title: `${TP}.FN_CONTACT_INFO_TITLE`,
      subtitle: `${TP}.FN_FESTIVAL_CONTACT_INFO_SUBTITLE`,
      form: <FestivalContacts goToNextTab={() => goToTab(tabValues.digital)} />,
      isFilled: checkCompletion(completedSections, COMPLETED_PROFILE_SECTIONS_NAMES.CONTACTS),
    },
    [tabValues.digital]: {
      value: tabValues.digital,
      name: `${TP}.FN_EDIT_ARTIST_PROFILE_DIGITAL_TAB`,
      title: `${TP}.FN_EDIT_ARTIST_PROFILE_DIGITAL_TAB`,
      subtitle: `${TP}.FN_DIGITAL_PRESENCE_SUBTITLE`,
      form: <FestivalDigitalPresence goToNextTab={() => goToTab(tabValues.staff)} />,
      isFilled: checkCompletion(completedSections, COMPLETED_PROFILE_SECTIONS_NAMES.DIGITAL_PRESENCE),
    },
    [tabValues.staff]: {
      value: tabValues.staff,
      name: `${TP}.FN_STAFF_TITLE`,
      form: <FestivalStaff goToNextTab={() => goToTab(tabValues.venues)} festival={festival} />,
      isFilled: checkCompletion(completedSections, COMPLETED_PROFILE_SECTIONS_NAMES.MANAGEMENT_STAFF),
    },
    [tabValues.venues]: {
      value: tabValues.venues,
      name: `${TP}.m_VENUES`,
      form: <FestivalVenues goToNextTab={() => goToTab(tabValues.images)} festival={festival} />,
      isFilled: checkCompletion(completedSections, COMPLETED_PROFILE_SECTIONS_NAMES.VENUES),
    },
    // [tabValues.video]: {
    //   value: tabValues.video,
    //   name: `${TP}.m_VIDEO`,
    //   title: `${TP}.FN_VIDEO_TITLE`,
    //   subtitle: `${TP}.FN_EDIT_ARTIST_PROFILE_VIDEO_SUBTITLE`,
    //   form: <FestivalVideo goToNextTab={() => goToTab(tabValues.images)} />,
    //   isFilled: false,
    // },
    [tabValues.images]: {
      value: tabValues.images,
      name: `${TP}.m_IMAGES`,
      form: <FestivalImages goToNextTab={() => goToTab(tabValues.basic)} festival={festival} />,
      isFilled: false,
    },
    // [tabValues.press]: {
    //   value: tabValues.press,
    //   name: `${TP}.FN_PRESS_TITLE`,
    //   title: `${TP}.FN_PRESS_TITLE`,
    //   subtitle: `${TP}.FN_EDIT_ARTIST_PROFILE_REVIEWS_SUBTITLE`,
    //   form: <FestivalPress goToNextTab={() => goToTab(tabValues.basic)} />,
    //   isFilled: false,
    // },
  };

  const [selectedTab, selectTab] = React.useState(tabs[tabValues.basic]);

  const goToTab = tabName => {
    selectTab(tabs[tabName]);
  };

  return <EditLayout tabs={tabs} selectedTab={selectedTab} goToTab={goToTab} />;
}
EditFestival.propTypes = {
  festival: PropTypes.object,
};

EditFestival.defaultProps = {
  festival: {},
};

export default memo(EditFestival);
